import { render } from "./ModalPrintWitnessShipment.vue?vue&type=template&id=6a1e4c01"
import script from "./ModalPrintWitnessShipment.vue?vue&type=script&lang=js"
export * from "./ModalPrintWitnessShipment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__